import { render, staticRenderFns } from "./UtUpload.vue?vue&type=template&id=3f03baca&scoped=true"
import script from "./UtUpload.vue?vue&type=script&lang=js"
export * from "./UtUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f03baca",
  null
  
)

export default component.exports